const newsButton = () => {
  const judgeTarget = document.getElementById('js-home-news');
  const buttonItem = document.querySelector('.p-news__button') as HTMLDivElement;

  if (judgeTarget !== null && buttonItem !== null) {
    const countItem = document.querySelectorAll('.p-news__item');
    if (countItem.length <= 6) {
      buttonItem.style.display = 'none';
    } else {
      buttonItem.style.display = 'block';
    }
  }
};
export { newsButton };
